<template>
  <div>
    <bd-table-list
      :breadcrumb="breadcrumb"
      title="Prospection"
      autocomplete_idHistory="prospects"
      autocomplete_field="prospect.title"
      bdTable="prospect"
      :actions="actions"
      :fields="fields"
      :Api="Api"
      ref="prospect_resource"
      defaultOrder="update_date"
      defaultSort="DESC"
      @suppress_prospect="suppress"
      @create_creditor="create"
    >
      <template v-slot:menu>
        <b-button variant="info" @click="newImport()" class="mb-3"
          >Nouvelle recherche d'entreprises</b-button
        >
        <b-alert show v-if="info" dismissible>{{ info }}</b-alert>
      </template>
      <template v-slot:cell(title)="data">
        <span class="d-block"
          >{{ data.item.title
          }}<span class="ml-3" v-if="data.item.creditor_exists == 'yes'"
            ><b-icon-exclamation-circle-fill
              variant="danger"
            ></b-icon-exclamation-circle-fill></span
        ></span>
        <b-img
          class="mt-2"
          v-if="data.item.logo"
          thumbnail
          rounded
          :src="data.item.logo"
          fluid
          alt="Logo"
        ></b-img>
      </template>
      <template v-slot:cell(href)="data">
        <a :href="'https://www.pagesdor.be' + data.item.href" target="_blank"
          >Plus d'info</a
        >
      </template>
      <template v-slot:cell(locality)="data">
        {{ data.item.locality }} ({{ data.item.postal_code }})
      </template>
      <template v-slot:cell(phone)="data">
        <b-input
          @blur="save_prospect(data.item)"
          v-model="data.item.phone"
        ></b-input>
      </template>
      <template v-slot:cell(status)="data">
        <b-row>
          <b-col
            :lg="
              data.item.status == 'to_contact' ||
              data.item.status == 'to_recontact'
                ? '9'
                : '12'
            "
          >
            <b-select
              style="width: 100%"
              @change="save_prospect(data.item)"
              v-model="data.item.status"
              :options="status_options"
            >
            </b-select>
          </b-col>
          <b-col
            lg="3"
            v-if="
              data.item.status == 'to_contact' ||
              data.item.status == 'to_recontact'
            "
          >
            <b-button @click="telephone(data.item)" variant="success">
              <b-icon-telephone-outbound-fill
                variant="light"
              ></b-icon-telephone-outbound-fill>
            </b-button>
          </b-col>
          <b-col lg="12" v-if="data.item.date_recall" class="mt-2 ml-2">
            le {{ getDate(data.item.date_recall) }}
          </b-col>
          <b-col lg="12" v-if="data.item.note.trim() !== ''">
            <div class="m-2 p-2 border rounded">{{ data.item.note }}</div>
          </b-col>
        </b-row>
      </template>
      <template v-slot:cell(negotiateurID)="data">
        <span v-if="data.item.initiale">{{ data.item.initiale }}</span>
        <span v-else>Non attribué</span>
      </template>
    </bd-table-list>
    <b-modal
      v-if="client_to_contact !== null"
      id="modal-telephone"
      size="lg"
      title="Contacter le client potentiel"
      hide-footer
    >
      <b-row>
        <b-col lg="12">
          <label>Entreprise</label>
          <h5>{{ client_to_contact.title }}</h5>
        </b-col>
        <b-col lg="12">
          <label>Numéro à composer</label>
          <h5>{{ client_to_contact.phone }}</h5>
        </b-col>

        <b-col lg="12">
          <label>Note</label>
          <b-textarea rows="10" v-model="client_to_contact.note"></b-textarea>
        </b-col>
        <b-col class="mt-2" lg="12">
          <label for="example-input"
            >Date à laquelle il faut recontacter le client / Date de
            rendez-vous</label
          >
          <b-input-group class="mb-3">
            <b-form-datepicker
              v-model="client_to_contact.date_recall"
              right
              locale="fr-BE"
              aria-controls="example-input"
            ></b-form-datepicker>
            <b-form-timepicker
              v-model="client_to_contact.time_recall"
              right
              locale="fr-BE"
              aria-controls="example-input"
            ></b-form-timepicker>
          </b-input-group>
        </b-col>
        <b-col class="text-right mt-3">
          <b-button @click="$bvModal.hide('modal-telephone')">Annuler</b-button>
          <b-button variant="info" @click="a_recontacter()" class="ml-3"
            >À recontacter</b-button
          >
          <b-button variant="danger" @click="pas_interesse()" class="ml-3"
            >Pas intéressé</b-button
          >
          <b-button variant="success" @click="rendez_vous_pris()" class="ml-3"
            >Rendez-vous pris</b-button
          >
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      id="modal-recherche-entreprises"
      size="lg"
      title="Nouvelle recherche d'entreprises"
      hide-footer
    >
      <b-row>
        <b-col lg="6">
          <label>Activité</label>
          <b-select
            v-model="activity"
            :options="activities"
            @change="n_hits = 0"
          >
          </b-select>
        </b-col>
        <b-col lg="6">
          <label>Localité</label>
          <b-input v-model="locality" @input="n_hits = 0"></b-input>
        </b-col>
        <b-col lg="6" class="mt-2">
          <label>Attribuer à</label>
          <b-select
            v-model="nego_attribution"
            :options="nego_options"
          ></b-select>
        </b-col>
        <b-col lg="6"></b-col>
        <b-col lg="12" class="mt-3">
          <b-alert v-if="n_hits > 0" show variant="success"
            >Nombre d'entreprises trouvées : {{ n_hits }}</b-alert
          >
        </b-col>
        <b-col lg="12" class="mt-3" v-if="importing">
          <label>Importation en cours</label>

          <b-progress variant="success" height="2rem"  :max="100" show-progress animated>
            <b-progress-bar :value="percentage"> {{ percentage }} %</b-progress-bar>
          </b-progress>
        </b-col>
        <b-col class="text-right mt-3">
          <b-button @click="$bvModal.hide('modal-recherche-entreprises')"
            >Annuler</b-button
          >
          <b-button
            :disabled="
              activity.trim() == '' ||
              locality.trim() == '' ||
              searching_hits ||
              importing
            "
            variant="success"
            @click="
              n_hits > 0
                ? pagesdor({ action: 'import' })
                : pagesdor({ action: 'hits' })
            "
            class="ml-3"
            ><b-icon
              v-if="searching_hits || importing"
              class="mr-2"
              icon="arrow-clockwise"
              animation="spin"
            ></b-icon
            >{{ n_hits > 0 ? "Importer" : "Rechercher" }}</b-button
          >
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import BdTableList from "@/components/BdTableList";
import String from "@/services/String.js";
import DateTime from "@/services/DateTime.js";
import prospects from "@/services/prospects.js";
import moment from "moment";
//import Negotiator from "@/components/Negotiator";
export default {
  name: "prospects",
  components: {
    BdTableList,
  },
  created() {
    prospects.categories().then((response) => {
      this.activities = response.data.categories.map((x) => {
        return { value: x, text: x };
      });
      this.nego_options = response.data.negos.map((x) => {
        return {
          value: x.ID,
          text: x.initiale + " (" + x.prenom + " " + x.nom + ")",
        };
      });
      this.activity = this.activities[0].value;
      this.nego_attribution = this.$store.getters.negoID;
    });
  },
  methods: {
    getDate(d) {
      return moment(d).format("DD/MM/YYYY à HH:mm");
    },
    company(str) {
      return String.company(str);
    },
    toDate(d) {
      return DateTime.humanDate(d);
    },
    suppress(payload) {
      payload.status = "suppressed";
      payload.date_recall = null;
      this.save_prospect(payload);
    },
    rendez_vous_pris() {
      this.client_to_contact.status = "appointment_made";
      this.client_to_contact.counter++;
      this.client_to_contact.date_recall =
        this.client_to_contact.date_recall.substring(0, 10) +
        " " +
        this.client_to_contact.time_recall;
      this.save_prospect(this.client_to_contact);
      this.$bvModal.hide("modal-telephone");
    },
    pas_interesse() {
      this.client_to_contact.status = "not_interested";
      this.client_to_contact.date_recall = null;
      this.client_to_contact.counter++;
      this.save_prospect(this.client_to_contact);
      this.$bvModal.hide("modal-telephone");
    },
    a_recontacter() {
      this.client_to_contact.status = "to_recontact";
      this.client_to_contact.counter++;
      this.client_to_contact.date_recall =
        this.client_to_contact.date_recall.substring(0, 10) +
        " " +
        this.client_to_contact.time_recall;
      this.save_prospect(this.client_to_contact);
      this.$bvModal.hide("modal-telephone");
    },
    telephone(item) {
      this.client_to_contact = item;
      this.client_to_contact.date_recall = moment()
        .add(1, "week")
        .format("YYYY-MM-DD");
      this.client_to_contact.time_recall = moment().format("HH:mm");
      this.$nextTick(() => {
        this.$bvModal.show("modal-telephone");
      });
    },

    newImport() {
      this.n_hits = 0;
      this.$bvModal.show("modal-recherche-entreprises");
    },

    pagesdor(options = {}) {
      this.percentage = null;
      if (options.action) {
        if (options.action == "import") {
          this.importing = true;
          options.n_matches = this.n_hits;
        } else if (options.action == "hits") {
          this.searching_hits = true;
        }
      }
      prospects
        .import_prospect({
          locality: this.locality,
          activity: this.activity,
          nego: this.nego_attribution,
          options: options,
        })
        .then((response) => {
          if (response.data.success) {
            if (options.action && options.action == "hits") {
              this.n_hits = response.data.hits;
              this.searching_hits = false;
              return;
            }
            if (response.data.continue) {
              this.offset = response.data.offset;
              this.percentage = response.data.percentage;
              this.continue();
            } else {
              this.$refs.prospect_resource.submitSearch();
              this.$bvModal.hide("modal-recherche-entreprises");
              this.importing = false;
            }
          } else {
            this.$bvModal.hide("modal-recherche-entreprises");
            this.importing = false;
            this.info = response.data.message;
          }
        });
    },
    continue() {
      prospects
        .import_prospect({
          locality: this.locality,
          activity: this.activity,
          nego: this.nego_attribution,
          options: {
            action: "import",
            offset: this.offset,
            n_matches: this.n_hits,
          },
        })
        .then((response) => {
          if (response.data.success) {
            if (response.data.continue) {
              this.offset = response.data.offset;
              this.percentage = response.data.percentage;
              this.continue();
            } else {
              this.$refs.prospect_resource.submitSearch();
              this.$bvModal.hide("modal-recherche-entreprises");
              this.importing = false;
            }
          } else {
            this.info = response.data.message;
            this.$bvModal.hide("modal-recherche-entreprises");
            this.importing = false;
          }
        });
    },
    create(payload) {
      prospects
        .create_creditor({
          prospect_id: payload.ID,
        })
        .then((response) => {
          if (response.data.success) {
            //this.$router.push({name : 'creditorView', params: {id: response.data.id }});
            let routeData = this.$router.resolve({
              name: "creditorView",
              params: { id: response.data.id },
            });
            window.open(routeData.href, "_blank");
          }
        });
    },
    save_prospect(prospect) {
      prospects
        .update_prospect({
          prospect_id: prospect.ID,
          prospect: prospect,
        })
        .then((response) => {
          if (response.data.success) {
            this.$bvToast.toast("prospect mise à jour", {
              title: `Recuperator`,
              toaster: "b-toaster-top-right",
              variant: "success",
              autoHideDelay: 500,
              solid: false,
            });
            this.$refs.prospect_resource.submitSearch(true, false);
          }
        });
    },
    /*newNegotiator() {
      this.negotiator_id = "new";
      this.$bvModal.show("modal-ajouter-negotiator");
    },
    editNegotiator(payload) {
      this.negotiator_id = payload.ID;
      this.$bvModal.show("modal-modifier-negotiator");
    },
    deleteNegotiator(payload) {
      negotiators
        .delete_negotiator({
          negotiator_id: payload.ID,
        })
        .then((response) => {
          if (response.data.success) {
            this.$refs.negotiator_resource.submitSearch(true);
          }
        });
    }, */
  },
  data() {
    return {
      Api: prospects,
      prospect_id: null,
      activity: "",
      activities: [],
      locality: "",
      percentage: 0,
      importing: false,
      n_hits: 0,
      offset: null,
      searching_hits: false,
      info: null,
      nego_attribution: null,
      nego_options: [],
      client_to_contact: null,
      status_options: [
        { value: "to_contact", text: "À contacter" },
        { value: "to_recontact", text: "À recontacter" },
        { value: "not_interested", text: "Pas intéressé" },
        { value: "appointment_made", text: "Rendez-vous pris" },
        { value: "converted", text: "Client à créer" },
        { value: "suppressed", text: "Supprimé" },
      ],
      breadcrumb: [
        {
          text: "Gestion",
          to: { name: "home" },
        },

        {
          text: "Prospection",
          active: true,
        },
      ],
      actions: [
        {
          label: "Éditer",
          event: "edit_prospect",
          variant: "success",
          icon: "pencil-square"
        },
        {
          label: "Créer le créancier",
          event: "create_creditor",
          icon: "check-circle-fill"
        },
        {
          label: "Supprimer",
          event: "suppress_prospect",
          icon: "x-square",
          variant: "danger",
          condition: () => this.$store.getters.isSuperAdmin
        },
      ],
      fields: [
        {
          key: "title",
          label: "Nom",
          sortable: true,
        },
        {
          key: "activity",
          label: "Activité",
          sortable: true,
        },
        {
          key: "locality",
          label: "Localité",
          sortable: true,
        },

        {
          key: "phone",
          label: "Téléphone",
        },

        {
          key: "status",
          label: "statut",
        },
        {
          key: "counter",
          label: "appels",
          class: "text-center",
        },
        {
          key: "href",
          label: "",
          sortable: true,
        },
        {
          key: "negotiateurID",
          label: "Attribué à",
          sortable: true,
        },
        {
          key: "actions",
          label: "Actions",
          sortable: false,
          thStyle: "width:100px",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
</style>